import { type FC } from 'react';
import classNames from 'classnames/bind';
import { type ViewportHandlePropsTypes } from './types/propsType';
import { ViewportThemes } from './types/enums';
import styles from './ViewportHandle.module.scss';

const cx = classNames.bind(styles);
/**
 * @description ViewportHandle provides a button-like component to resize layouts.
 * Props ->
 * viewPortTheme: theme (light or dark) of viewport handle;
 * disabled: boolean to disable the handle click;
 */
const ViewportHandle: FC<ViewportHandlePropsTypes> = (props: ViewportHandlePropsTypes) => {
  const { onClick, viewPortTheme = ViewportThemes.LIGHT, disabled = false } = props;
  const buttonClassName = cx('viewport-handle-button', [viewPortTheme], {
    disabled: disabled,
  });
  return (
    <div
      id="handle"
      aria-label="handle"
      className={styles['viewport-handle-container']}
      data-testid="viewport-handle-testid"
    >
      <button className={buttonClassName} onClick={onClick} data-testid="viewport-handle-button-testid">
        <div className={styles['center']}></div>
      </button>
    </div>
  );
};
ViewportHandle.displayName = 'ViewportHandle';
export default ViewportHandle;
export type { ViewportHandlePropsTypes } from './types/propsType';
export { ViewportThemes } from './types/enums';
